import { ReactNode } from 'react';
import classes from './switch.module.scss';
import { Typography } from './typography';

interface SwitchProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string | ReactNode;
  id: string;
}

export const Switch = ({ checked, onChange, label, id }: SwitchProps) => {
  return (
    <div className={classes.switchContainer}>
      <input
        checked={checked}
        onChange={onChange}
        className={classes.switchCheckbox}
        id={id}
        type='checkbox'
      />
      <label className={classes.switchLabel} htmlFor={id}>
        <span className={classes.switchButton} />
      </label>
      {typeof label === 'string' ? (
        <Typography variant='text-sm' className={classes.label}>
          {label}
        </Typography>
      ) : (
        label
      )}
    </div>
  );
};
